
import React from "react";
import Page from "../../../../layout/web/Page";
import Title from "../../../../components/Common/Title";
import Connector from "../../../../redux/connector";
import {GetUserToken} from "../../../../api/token";
import PluginAddDeleteList from "../../../../components/Common/PluginAddDeleteList2";
import {PostToPbx} from "../../../../api/http-post";
import {fetchDataEntity} from "../../../../api/entity-data";



class SettingExtraConfigureAreaSitePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Data: [],
            Companies: [],
            Projects: [],
            Modules:[],
            Sites:[],
            Areas:[],
            isLoading: false,
            company: "",
            component: "list",
            newEntry: {},
        }
    }

    componentDidMount = async () => {
        let userInfo = GetUserToken();
        await fetchDataEntity("Companies", "client/entity", "company", this)
        //await this.loadData2("PastelProject", "Projects",[/*{key:"org",val:userInfo.Org}*/])
        await this.loadInitialData()
    }

    loadInitialData = async () => {
        await this.loadData("modules", "Modules");

        await this.loadData("TermsSite", "Sites");
        await this.loadData("PayrollVirtualArea", "Areas");
    }
    loadData2 = async (targetEntity, stateKey,params) => {
        let _this = this;
        let userInfo = GetUserToken();
        let table = targetEntity;
        let hub = {};
        hub.Org = userInfo.Org;
        let post = {}
        post.Entity = table;
        post.Data = {};
        post.Params = params;
        let endpoint = "/common/entity/" + table + "/list";
        this.setState({
            isLoading: true,
        })

        await PostToPbx(post, endpoint, async (data) => {
            console.log("loaddata 2> ",data)
            await _this.setState({
                [stateKey]: data.RESULT
            })
        });
    }
    loadData = async (targetEntity, stateKey) => {
        let _this = this;
        let userInfo = GetUserToken();
        let table = targetEntity;
        let hub = {};
        hub.Org = userInfo.Org;
        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = {};
        post.Params = {}
        post.Entity = table;
        let endpoint = "/common/entity/" + table + "/list";
        this.setState({
            isLoading: true,
        })

        await PostToPbx(post, endpoint, async (data) => {
            await _this.setState({
                [stateKey]: data.RESULT
            })
        });
    }

    getModuleList = () => {
        let ls = [];
        for (let i in this.state.Modules) {
            let row = this.state.Modules[i];
            if (row.org === this.state.newEntry.org) {
                ls.push({
                    key: row.name,
                    val: row.name
                });
            }
        }
        return ls;
    }
    getCompanyList = () => {
        let ls = [];
        for (let i in this.state.Companies) {
            let row = this.state.Companies[i];
            ls.push({
                key: row.CustomerNumber,
                val: row.Name,
            });
        }
        return ls;
    }
    getClientOption=()=>{
        let ls = [];
        for (let i in this.state.Clients) {
            let row = this.state.Clients[i];
            if (row.org === this.state.newEntry.selectedCompany) {
                ls.push({
                    key: row.name,
                    val: row.name
                });
            }
        }
        return ls;
    }
    getProjectOption=()=>{
        let ls = [];
        console.log("all projects: ",this.state.Projects)
        for (let i in this.state.Projects) {
            let row = this.state.Projects[i];
            if (row.org === this.state.newEntry.selectedCompany) {
                ls.push({
                    key: row.name,
                    val: row.name
                });
            }
        }
        return ls;
    }
    getSiteOption=()=>{
        let ls = [];

        for (let i in this.state.Sites) {
            let row = this.state.Sites[i];
            if (row.org !== this.state.newEntry.selectedCompany) {
                continue
            }
            if (row.ref !== this.state.newEntry.project) {
                continue
            }
            ls.push({
                key: row.name,
                val: row.name
            });
        }
        console.log("all Sites: ",ls)
        return ls;
    }
    getAreaOption=()=>{
        let ls = [];

        for (let i in this.state.Areas) {
            let row = this.state.Areas[i];
            if (row.org !== this.state.newEntry.selectedCompany) {
                continue
            }
            if (row.project !== this.state.newEntry.project) {
                continue
            }
            ls.push({
                key: row.name,
                val: row.name
            });
        }
        console.log("all Sites: ",ls)
        return ls;
    }


    render() {
        const projectOptions = this.getProjectOption();
        const companyOptions = this.getCompanyList();
        const siteOptions = this.getSiteOption()

        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                }}>
                    <Title style={styles.title}>Setup Labour Area Site</Title>
                    <div style={{minWidth: "100%", padding: 10}}>
                        <PluginAddDeleteList
                            _this={this}
                            targetEntity={"PayrollVirtualAreaSite"}
                            depending={{
                                "org": {
                                    targetKey: "CustomerNumber",
                                    displayKey: "Name",
                                    storageTable: "Companies"
                                }
                            }}
                            fields={[
                                {
                                    name: "org",
                                    dataType: "option",
                                    required: true,
                                    label: "Organization",
                                    options: companyOptions,
                                    depending: {stateKey: "org", displayKey: "Name", storageTable: "Companies"}
                                },
                                {
                                    name: "project",
                                    dataType: "option",
                                    required: true,
                                    label: "Project",
                                    options: this.getModuleList(),
                                    depending: {stateKey: "org", displayKey: "Name", storageTable: "Modules"}
                                },
                                {
                                    name: "area",
                                    dataType: "option",
                                    required: true,
                                    label: "Area",
                                    options: this.getAreaOption(),
                                    depending: {}
                                },
                                {
                                    name: "site",
                                    dataType: "option",
                                    required: true,
                                    label: "Site",
                                    options: this.getSiteOption(),
                                    depending: {}
                                },

                            ]}
                            deleteKeys={[
                                {key: "org", type: "string"},
                                {key: "project", type: "string"},
                                {key: "area", type: "string"},
                                {key: "site", type: "string"},
                            ]}
                            stateArray={"Data"}
                            table={"PayrollVirtualAreaSite"}
                            addFormText={"Labour Area Site"}
                            stepTitle={"Setup new labour area site"}

                            filterByCompany={true}



                        />

                    </div>
                </div>
            </Page>
        )
    }

}

export default Connector(SettingExtraConfigureAreaSitePage);

const styles = {
    container: {},
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    }
}

